module.exports = __webpack_public_path__ + "img/telegram.2b1f366b.svg";